import React, { useEffect, useState } from "react";
import HeaderPrint from "../components/HeaderPrint";
import "../styles/print.stye.css";
import { thaiMonths } from "../../../../../utils/monthThai";
import SignaturePrint from "../components/SignaturePrint";
import CommentPrint from "../components/CommentPrint";
import RenderValue from "../components/RenderValue";
import { EmployeeApi } from "../../../../../api/employee/employee.api";
import { formatDateToThai } from "../../../../../utils/date.utils";

const Form01 = ({
  header,
  sub_header,
  title,
  send_to,
  data,
  dataReportDetail,
  dataEmployee,
}: {
  header: string;
  sub_header: string;
  title: string;
  send_to: string;
  data: any;
  dataReportDetail: any;
  dataEmployee: any;
}) => {
  const {
    day: start_leave_day,
    month: start_leave_month,
    year: start_leave_year,
  } = formatDateToThai(
    dataReportDetail ? dataReportDetail?.main?.leave_peroid_date[0] : null
  );

  const {
    day: end_leave_day,
    month: end_leave_month,
    year: end_leave_year,
  } = formatDateToThai(
    dataReportDetail ? dataReportDetail?.main?.leave_peroid_date[1] : null
  );

  return (
    <div>
      <HeaderPrint
        header={header}
        sub_header={sub_header}
        title={title}
        send_to={send_to}
        data={{
          title: "วิทยาลัยพุทธศาสนานานาชาติ",
          date: data.created_date,
        }}
      />
      {/* line 1 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ข้าพเจ้า"}
          end_label={null}
          length={90}
          value={dataEmployee?.first_name}
          isParagraph={true}
        />
        {/*  */}
        <RenderValue
          start_label={"ฉายา/นามสกุล"}
          end_label={null}
          length={95}
          value={
            [dataEmployee?.buddhist_name, dataEmployee?.last_name]
              .filter(Boolean)
              .join(" ") || null
          }
          isParagraph={false}
        />
      </div>
      {/* line 2 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ตำแหน่ง"}
          end_label={null}
          length={60}
          value={dataEmployee?.work_history?.position_name}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เลขที่"}
          end_label={null}
          length={50}
          value={dataEmployee?.employee_no}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"สังกัด"}
          end_label={null}
          length={35}
          value={"IBSC"}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"แผนงาน"}
          end_label={null}
          length={45}
          value={dataEmployee?.department?.department_name_th}
          isParagraph={false}
        />
      </div>
      {/* line 3 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ขอลา"}
          end_label={null}
          length={100}
          value={title}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เนื่องจาก"}
          end_label={null}
          length={120}
          value={dataReportDetail?.condition?.reason ?? ""}
          isParagraph={false}
        />
      </div>
      {/* line 4 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ตั้งแต่วันที่"}
          end_label={null}
          length={20}
          value={start_leave_day ?? null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={40}
          value={start_leave_month ? thaiMonths[start_leave_month] : null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"พ.ศ"}
          end_label={null}
          length={25}
          value={start_leave_year ?? null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"ถึงวันที่"}
          end_label={null}
          length={20}
          value={end_leave_day ?? null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={40}
          value={end_leave_month ? thaiMonths[end_leave_month] : null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"พ.ศ"}
          end_label={null}
          length={25}
          value={end_leave_year ?? null}
          isParagraph={false}
        />
      </div>
      {/* line 5 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"มีกำนด"}
          end_label={"วัน"}
          length={40}
          value={dataReportDetail?.main?.leave_day ?? null}
          isParagraph={false}
        />

        {/*  */}
        <span className="ml-4">
          <RenderValue
            start_label={"ข้าพเจ้าได้ลา"}
            end_label={null}
            length={80}
            value={title}
            isParagraph={false}
          />
        </span>

        <RenderValue
          start_label={"ครั้งสุดท้ายเมื่อวันที"}
          end_label={null}
          length={30}
          value={null}
          isParagraph={false}
        />
      </div>
      {/* line 6 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={30}
          value={null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"พ.ศ"}
          end_label={null}
          length={25}
          value={null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"ถึงวันที่"}
          end_label={null}
          length={25}
          value={null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={30}
          value={null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"พ.ศ"}
          end_label={null}
          length={25}
          value={null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"มีกำนด"}
          end_label={"วัน"}
          length={20}
          value={null}
          isParagraph={false}
        />
      </div>
      {/* line 7*/}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ในละหว่างลาจะติดต่อกับข้าะเจ้าได้ที่"}
          end_label={null}
          length={100}
          value={dataReportDetail?.condition?.address ?? ""}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"ตำบล/แขวง"}
          end_label={null}
          length={50}
          value={dataReportDetail?.condition?.district_sub ?? ""}
          isParagraph={false}
        />
      </div>
      {/* line 8*/}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"อำเภอ/เขต"}
          end_label={null}
          length={45}
          value={dataReportDetail?.condition?.district ?? ""}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"จังหวัด"}
          end_label={null}
          length={45}
          value={dataReportDetail?.condition?.province ?? ""}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"รหัสไปรษฌีย์"}
          end_label={null}
          length={40}
          value={dataReportDetail?.condition?.postcode ?? ""}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"โทร"}
          end_label={null}
          length={40}
          value={dataReportDetail?.condition?.delegator_phone ?? ""}
          isParagraph={false}
        />
      </div>
      <br />
      {/* signature*/}
      <div className="w-full ml-24 space-content">
        <SignaturePrint
          title={"เรียนมา/นมัสการมาด้วยความเคารพ"}
          prefix={`ลงชื่อ`}
          position={""}
          isDate={false}
          isPosition={false}
          data={{}}
        />
      </div>

      <div className="w-full grid grid-cols-12 gap-4 mt-[20px]">
        <article className="w-full col-span-12 md:col-span-7 lg:col-span-7 sm:col-span-7">
          <p className="flex justify-center align-middle">
            <b>สถิติการลาในปีงบประมาฌนี้</b>
          </p>
          <table className="min-w-full border-collapse border border-gray-300">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-2 py-1  text-center  text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-300">
                  ประเภทการลา
                </th>
                <th className="px-2 py-1  text-center  text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-300">
                  ลามาแล้ว
                  <br />
                  (วันทำการ)
                </th>
                <th className="px-2 py-1  text-center  text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-300">
                  ลาครั้งนี้
                  <br />
                  (วันทำการ)
                </th>
                <th className="px-2 py-1  text-center  text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-300">
                  รวมเป็น
                  <br />
                  (วันทำการ)
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              <tr>
                <td className="px-2 py-1  text-center  whitespace-nowrap border border-gray-300">
                  ป่วย
                </td>
                <td className="px-2 py-1  text-center  whitespace-nowrap border border-gray-300">
                  0
                </td>
                <td className="px-2 py-1  text-center  whitespace-nowrap border border-gray-300">
                  0
                </td>
                <td className="px-2 py-1  text-center  whitespace-nowrap border border-gray-300">
                  0
                </td>
              </tr>
              <tr>
                <td className="px-2 py-1  text-center  whitespace-nowrap border border-gray-300">
                  กิจส่วนตัว
                </td>
                <td className="px-2 py-1  text-center  whitespace-nowrap border border-gray-300">
                  0
                </td>
                <td className="px-2 py-1  text-center  whitespace-nowrap border border-gray-300">
                  0
                </td>
                <td className="px-2 py-1  text-center  whitespace-nowrap border border-gray-300">
                  0
                </td>
              </tr>
              <tr>
                <td className="px-2 py-1  text-center  whitespace-nowrap border border-gray-300">
                  คลอดบุตร
                </td>
                <td className="px-2 py-1  text-center  whitespace-nowrap border border-gray-300">
                  0
                </td>
                <td className="px-2 py-1  text-center  whitespace-nowrap border border-gray-300">
                  0
                </td>
                <td className="px-2 py-1  text-center  whitespace-nowrap border border-gray-300">
                  0
                </td>
              </tr>
            </tbody>
          </table>
        </article>
        <article className="w-full col-span-12 md:col-span-5 lg:col-span-5 sm:col-span-5">
          <CommentPrint
            title={"ความเห็นของผู้บังคับบัญชา"}
            isCheckBoxApprove={false}
            sxTitle="justify-center title-personal-approve"
            amountLine={2}
            isParagraph={false}
            data={{
              isApprove: data.leave_status === "approve third" ? true : false,
              comment: data.leave_approve_second_comment ?? "",
            }}
            lengthDot={100}
          />
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </article>
      </div>

      <div className="w-full grid grid-cols-12">
        <article className="w-full col-span-12 md:col-span-6 lg:col-span-6 sm:col-span-6">
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={"ผู้ตรวจสอบ"}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </article>
        <article className="w-full col-span-12 md:col-span-6 lg:col-span-6 sm:col-span-6">
          <CommentPrint
            title={"คำสัางของผู้มีอำนาตอนุญาต"}
            isCheckBoxApprove={true}
            // sxTitle="justify-start title-personal-approve"
            sxTitle="justify-start"
            amountLine={2}
            isParagraph={false}
            data={{
              isApprove: data.leave_status === "approve third" ? true : false,
              comment: data.leave_approve_third_comment ?? "",
            }}
            lengthDot={125}
          />
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </article>
      </div>
    </div>
  );
};

export default Form01;
